import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'list-search',
  template: require('./list-search.component.html'),
  styles: [require('./list-search.scss')],
})
export class ListSearchComponent implements OnInit, OnDestroy {
  @Output() searchStr: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('search') searchElement: ElementRef;
  @Input() inputSearch: string;

  searchControl: FormControl;
  debounce: number = 50;
  showClearBtn: boolean = false;
  destroy$: Subject<boolean> = new Subject<boolean>();

  // todo: add coverage for the subsccribe function (dvn)
  ngOnInit(): void {
    this.searchControl = new FormControl('');
    this.searchControl.valueChanges
      .pipe(
        debounceTime(this.debounce),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
      )
      .subscribe(query => this.onSearchSubscription(query));

    if (this.inputSearch) {
      this.searchControl.setValue(this.inputSearch);
    }
  }

  onSearchSubscription(query: string): void {
    if (query !== null && query.length) {
      this.showClearBtn = true;
    } else {
      this.showClearBtn = false;
    }
    this.searchStr.emit(query);
  }

  clearSearch(): void {
    this.searchControl.setValue('');
    this.showClearBtn = false;
    this.searchElement.nativeElement.focus();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
